import React from "react";
import {IconProps} from "./types";

export const MixerIcon = ({fill}: IconProps) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 2C5.55228 2 6 2.44772 6 3V11.2695C6.59733 11.6155 7 12.2601 7 13C7 13.7398 6.5971 14.3835 6 14.7295V17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17V14.7295C3.4029 14.3835 3 13.7398 3 13C3 12.2601 3.40267 11.6155 4 11.2695V3C4 2.44772 4.44772 2 5 2ZM10 2C10.5523 2 11 2.44772 11 3V5.26953C11.5973 5.61546 12 6.26007 12 7C12 7.73976 11.5971 8.3835 11 8.72949V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V8.72949C8.4029 8.3835 8 7.73976 8 7C8 6.26007 8.40267 5.61546 9 5.26953V3C9 2.44772 9.44772 2 10 2ZM15 2C15.5523 2 16 2.44772 16 3V11.2695C16.5973 11.6155 17 12.2601 17 13C17 13.7398 16.5971 14.3835 16 14.7295V17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V14.7295C13.4029 14.3835 13 13.7398 13 13C13 12.2601 13.4027 11.6155 14 11.2695V3C14 2.44772 14.4477 2 15 2Z"
        fill={fill || "#6B7280"}
      />
    </svg>
  );
};
